import { FormEvent, useState } from 'react'

import { addFaqExample } from '../../../../api/faq'
import { ReactComponent as CheckmarkCircle } from '../../../../assets/icons/checkmark-circle.svg'
import { ReactComponent as Close } from '../../../../assets/icons/close.svg'

import styles from './faq-new-example.module.scss'

interface INewExampleFormProps {
    selectedFaqItem: string
    getDataFromApi: () => void
    onCancel: () => void
}

function NewExampleForm(props: INewExampleFormProps) {
    const { selectedFaqItem, getDataFromApi, onCancel } = props
    const [newExampleText, setNewExampleText] = useState('')

    const handleSaveExample = async (e: FormEvent) => {
        e.preventDefault()
        try {
            await addFaqExample(selectedFaqItem, newExampleText)
            getDataFromApi()
            setNewExampleText('')
        } catch (error) {
            console.error('ERROR:', error)
        }
    }

    const setAddButtonActive = () => !newExampleText.trim()

    return (
        <div className={styles.faqNewExample}>
            <form onSubmit={handleSaveExample}>
                <div className={styles.faqNewExample__row}>
                    <input
                        className={styles.faqNewExample__row__input}
                        type="text"
                        value={newExampleText}
                        onChange={(e) => setNewExampleText(e.target.value)}
                    />
                    <div className={styles.faqNewExample__buttonsWrapper}>
                        <button
                            type="submit"
                            className={`${styles.faqNewExample__borderBtn} ${
                                setAddButtonActive()
                                    ? styles.faqNewExample__disabledBtn
                                    : ''
                            }`}
                        >
                            <CheckmarkCircle />
                        </button>
                        <button
                            type="button"
                            className={styles.faqNewExample__borderBtn}
                            onClick={onCancel}
                        >
                            <Close />
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default NewExampleForm
